import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AppService } from '../../services/app.service';
import { Subscription } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-banner',
    imports: [TranslatePipe],
    templateUrl: './banner.component.html',
    styleUrl: './banner.component.scss'
})
export class BannerComponent {
  assetsUrl: string = '';

  private $appData: Subscription;
  data: any = {};
  currentRoute: string = '';

  constructor(appService: AppService, private apiService: ApiService, private router: Router) {
    this.assetsUrl = appService.ENV.ASSETS_BASE_URL;
    this.$appData = this.apiService.$appData.subscribe((data: any) => { this.data = data });
    this.router.events.subscribe(() => {
      var path = this.router.url.split("?")[0]
      this.currentRoute = path;
    });
    
    var path = this.router.url.split("?")[0]
    this.currentRoute = path;
  } 

  ngOnInit() {
    var data = this.apiService.getData();
    this.data = data;
  }

  ngOnDestroy(): void {
    this.$appData.unsubscribe();
  }
}
